import { PATH_MYORG } from "@/constants/URL";

import routerWithSidebar from "./routerWithSidebar";

export default {
  path: PATH_MYORG,
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: PATH_MYORG,
      name: "e361",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myOrg/index.vue")
      )
    }
  ]
};
